import React, { useState, useEffect, useRef } from 'react';
import YouTube from 'react-youtube';
import { useNavigate } from 'react-router-dom'; // 引入 useNavigate hook
import { EuiPanel, EuiIcon,EuiFlexGroup, EuiFlexItem, EuiButton, EuiSelect, EuiButtonIcon, EuiListGroup, EuiListGroupItem, EuiModal, EuiModalHeader, EuiModalBody, EuiModalFooter, EuiFieldText, EuiTextArea,  EuiDragDropContext,
    EuiDroppable,
    EuiDraggable, 
    EuiButtonEmpty,
    copyToClipboard,
    euiDragDropReorder} from '@elastic/eui';
import {TranslateLanguage} from './KeywordTranslator';
import '../style.css';
import logosmall from '../assets/CTBLogoCircle-Small.png';
import RadioModal from "./RadioModal"
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useAlert } from './AlertProvider';

const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
        autoplay: 1,
        playsinline: 1,
        enablejsapi: 1,
        // mute: 1, // 添加静音参数
        fullscreen: 1
    },
};
const opts_full = {
    height: '90%',
    width: '90%',
    playerVars: {
        autoplay: 1,
        playsinline: 1,
        enablejsapi: 1,
        // mute: 1, // 添加静音参数
        fullscreen: 1
    },
};

function RadioPageWithPlayer() {
    const [playlists, setPlaylists] = useState([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState(null);
    const [songs, setSongs] = useState([]);
    const [currentSong, setCurrentSong] = useState({ id: '', name: '' });
    const [initSong, setInitSong] = useState(null);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [newPlaylistName, setNewPlaylistName] = useState('');
    const [isPanelVisible, setIsPanelVisible] = useState(true); // 控制右侧面板是否可见
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showCreateRadioModal, setShowCreateRadioModal] = useState(false);
    const [showPlaylistToRadioModal, setshowPlaylistToRadioModal] = useState(false);
    const [newPlaylistVisibility, setNewPlaylistVisibility] = useState('private');
    const [newPlaylistDescription, setNewPlaylistDescription] = useState('');
    const [newPlaylistTags, setNewPlaylistTags] = useState('');
    const [newPlaylistCategory, setNewPlaylistCategory] = useState('');
    const [expandedPlaylist, setExpandedPlaylist] = useState(null); // 用于记录当前展开的歌单
    const [playlistDetails, setPlaylistDetails] = useState(null); // 用于存储歌单详情数据
    const [shareLink, setShareLink] = useState("");
    const navigate = useNavigate(); // 使用 useNavigate 创建 navigate 函数
    const playerRef = useRef(null); // 用 useRef 来存储 player 实例
    const [ytApiReady, setYtApiReady] = useState(false);
    const currentSongRef = useRef(currentSong);   // 使用 useRef 存储最新的 currentSong
    const songsRef = useRef(songs);
    const songtitleRef = useRef(null);
    const leftpanelRef = useRef(null);
    // const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
    const [isPortrait, setIsPortrait] = useState(() =>
        window.matchMedia('(orientation: portrait)').matches
    );
    const showAlert = useAlert();
    const [modalProps, setModalProps] = useState({
        userId: '',
        playlistId: '',
        playlisttype: ''
      });

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // 从 sessionStorage 获取 userId
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userId = user ? user.id : null;
    const token = sessionStorage.getItem("token");  // 从 localStorage 中获取 token
    let userRole = "";
    if (token) {
        const decodedToken = jwtDecode(token);  // 解码 token
        // console.log(decodedToken);  // 检查 token 中的内容，包括角色信息
        userRole = decodedToken.role;  // 获取角色信息
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://www.youtube.com/iframe_api";
        script.async = true;
        script.onload = () => {
        //   console.log("YouTube IFrame API script loaded");
    
        // Check if the YT object is already available
        if (window.YT && window.YT.Player) {
            // console.log("YT object is available, API is ready");
            setYtApiReady(true);
        }
        };
        document.body.appendChild(script);
    
        window.onYouTubeIframeAPIReady = () => {
        //   console.log("YouTube IFrame API is ready");
        setYtApiReady(true);
        };
    
        // Fallback if the API doesn't signal readiness
        setTimeout(() => {
        if (window.YT && window.YT.Player && !ytApiReady) {
            console.log("Fallback: YT object available, setting ytApiReady to true");
            setYtApiReady(true);
        }
        }, 5000); // Fallback after 5 seconds
    }, []);
  
    // 当 ytApiReady 和 currentSong 都准备好时初始化播放器
    useEffect(() => {
        if (
            !ytApiReady ||
            !initSong?.resourceId ||
            playerRef.current
        ) {
            return;
        }

        playerRef.current = new window.YT.Player(
            'youtube-player',
            {
            height: '100%',
            width: '100%',
            videoId: initSong.resourceId,
            playerVars: {
                autoplay: isIOS ? 0 : 1,
                controls: 1,
                mute: isIOS ? 1 : 0,
                playsinline: 1
            },
            events: {
                onStateChange: onPlayerStateChange
            }
            }
        );
    }, [ytApiReady, initSong]);

    useEffect(() => {
        return () => {
            playerRef.current?.destroy?.();
            playerRef.current = null;
        };
    }, []);

    // useEffect(() => {
    //     const appViewport =
    //         document.querySelector('.appViewport');

    //     appViewport?.classList.add(
    //         'admin-radio-page-active'
    //     );

    //     return () => {
    //         appViewport?.classList.remove(
    //         'admin-radio-page-active'
    //         );
    //     };
    // }, []);
  
    useEffect(() => {
        if (
            !playerRef.current ||
            !currentSong?.resourceId
        ) {
            return;
        }

        if (
            playerRef.current.getPlayerState &&
            playerRef.current.getPlayerState() !== -1
        ) {
            playerRef.current.loadVideoById(
            currentSong.resourceId
            );

            if (isIOS) {
            playerRef.current.unMute();
            }
        }
    }, [currentSong, isIOS]);


    // 同步更新 currentSongRef
    useEffect(() => {
        currentSongRef.current = currentSong;
    }, [currentSong]);

    useEffect(() => {
        songsRef.current = songs;
    }, [songs]);


    const SongItem = ({ song, currentSong, handleSongClick, handleDeleteSong }) => {
        const songItemRef = useRef(null);

        useEffect(() => {
            if (songItemRef.current && currentSong && currentSong.resourceId === song.resourceId) {
                songItemRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, [currentSong, song]);

        return (
            <div ref={songItemRef}>
            <EuiPanel
                hasShadow={false}
                paddingSize="none"
                color={currentSong.resourceId === song.resourceId ? "danger" : "none"}
                hasBorder={true}
            >
                <EuiFlexGroup wrap={false} alignItems="center" gutterSize="s" style={{ flexWrap: 'nowrap' }}>
                    <EuiFlexItem grow={false} style={{ flexShrink: 0, flexBasis: '20px', minWidth: '20px', maxWidth: '20px' }}>
                        <EuiIcon type="grab" />
                    </EuiFlexItem>
                    <EuiFlexItem grow={true} style={{ flexShrink: 1, flexBasis: '100%' }}>
                        <EuiListGroupItem
                            className={`song-item ${currentSong && currentSong.resourceId === song.resourceId ? 'playing-song' : ''}`}
                            style={{ zIndex: 1 }}
                            // label={`${song.name.length > 12 ? TranslateLanguage(localStorage.userLanguage, song.name.substring(0, 12)) + '...' : TranslateLanguage(localStorage.userLanguage, song.name)}`}
                            label={
                                <>
                                {isPortrait
                                    ? TranslateLanguage(localStorage.userLanguage, song.name)
                                    : (song.name.length > 12 ? TranslateLanguage(localStorage.userLanguage, song.name.substring(0, 12)) + '...' : TranslateLanguage(localStorage.userLanguage, song.name))}
                                </>
                            }
                            icon={
                                <>
                                    <EuiIcon
                                        type="cross"
                                        // className="delete-icon"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteSong(song);
                                        }}
                                        style={{ marginLeft: '0px', marginRight: '10px', cursor: 'pointer' }}
                                    />
                                    <EuiIcon type="play" style={{ marginRight: '5px' }} />
                                </>
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                e.currentTarget.focus();  // 强制获取焦点
                                handleSongClick(song);
                            }}
                            // extraAction={{
                            //     iconType: 'trash',
                            //     onClick: (e) => {
                            //         e.stopPropagation();
                            //         handleDeleteSong(song);
                            //     },
                            //     'aria-label': '删除歌曲',
                            //     style: { marginLeft: 'auto', cursor: 'pointer' }
                            // }}
                        />
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiPanel>
            </div>
        );
    };

    // function setViewportDimensions() {
    //     let height = 44;
    //     let calwidth;
    //     let calheight;
    //     // if (songtitleRef.current) {
    //     //     height = songtitleRef.current.offsetHeight + 20;
    //     //     // console.log('Height of the h3 element:', height + 'px');
    //     // }
    //     calwidth = window.innerWidth - 30;
    //     calheight = window.innerHeight - height;
    //     if (calwidth*9/16 > calheight)
    //         document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - height}px`);
    //     else
    //         document.documentElement.style.setProperty('--viewport-height', `${calwidth*9/16}px`);
    //     document.documentElement.style.setProperty('--viewport-width', `${window.innerWidth - 20}px`);
    //     // document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - height}px`);
    // }

    // // 初始化时设置值
    // setViewportDimensions();

    // // 监听窗口大小变化事件
    // window.addEventListener('resize', setViewportDimensions);
    
    // useEffect(() => {
    //     const handleResize = () => {
    //       setIsPortrait(window.innerHeight > window.innerWidth);
    //     };
    
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    //   }, []);

    useEffect(() => {
        const updateViewportDimensions = () => {
            const viewport = window.visualViewport;

            const width = Math.round(
            viewport?.width ?? window.innerWidth
            );

            const height = Math.round(
            viewport?.height ?? window.innerHeight
            );

            const portrait = window.matchMedia(
            '(orientation: portrait)'
            ).matches;

            const playerWidth = portrait
            ? Math.max(0, width - 20)
            : width * 0.68;

            const availableHeight = Math.max(
            0,
            height - 44
            );

            const playerHeight = Math.min(
            playerWidth * 9 / 16,
            availableHeight
            );

            document.documentElement.style.setProperty(
            '--viewport-height',
            `${playerHeight}px`
            );

            document.documentElement.style.setProperty(
            '--viewport-width',
            `${Math.max(0, width - 20)}px`
            );

            setIsPortrait(portrait);
        };

        updateViewportDimensions();

        window.addEventListener(
            'resize',
            updateViewportDimensions
        );

        window.visualViewport?.addEventListener(
            'resize',
            updateViewportDimensions
        );

        return () => {
            window.removeEventListener(
            'resize',
            updateViewportDimensions
            );

            window.visualViewport?.removeEventListener(
            'resize',
            updateViewportDimensions
            );
        };
    }, []);

    const onPlayerStateChange = (event) => {
    switch (event.data) {
        case YT.PlayerState.PLAYING:
        // setPlaying(true); // 更新状态为播放中
        if (isIOS){
            playerRef.current.unMute(); // 解除静音
            }
        break;
        case YT.PlayerState.PAUSED:
        // setPlaying(false); // 更新状态为暂停
        break;
        case YT.PlayerState.ENDED:
        handleSongEnd();
        break;
        default:
        break;
    }
    };

    useEffect(() => {
        axios.get(`/api/playlists`, {
            params: {
                userId: userId,
                type: 'radio'
            }
        })
        .then(response => {
            // console.log('Response:', response);
            const data = response.data;
            // console.log('Parsed JSON:', data);
            setPlaylists(data);
        })
        .catch(error => {
            console.error('Error fetching playlists:', error);
        });
    }, []);

    const handlePlaylistChange = (playlistId) => {
        if (expandedPlaylist === playlistId) {
            setExpandedPlaylist(null); // 如果点击的歌单已经展开，则合上
        } else {
            setSelectedPlaylist(playlistId);

            axios.get(`/api/playlists/${playlistId}/songs`)
            .then(response => {
                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const sortedSongs = response.data.sort((a, b) => a.order - b.order); // 按 order 排序
                setSongs(sortedSongs);
                setInitSong(sortedSongs[0]);
                setExpandedPlaylist(playlistId); // 展开新的歌单
            })
            .catch(error => {
                console.error('Error fetching songs:', error);
            });
        }
    };
    //删除歌曲的处理函数
    const handleDeleteSong = (songId) => {
        if (window.confirm(TranslateLanguage(localStorage.userLanguage, "確定從歌單中刪除這首詩歌？"))) {
            axios.delete(`/api/playlists/${selectedPlaylist}/songs/${songId.resourceId}`)
            .then(response => {
                if (response.status === 200) {
                    // 删除成功后更新前端的歌曲列表
                    setSongs(songs.filter(song => song.resourceId !== songId.resourceId));
                    showAlert(TranslateLanguage(localStorage.userLanguage, "刪除成功"));
                } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
                }
            })
            .catch(error => {
                console.error("删除歌曲时出错:", error);
                showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
            });
        }
    };    
    // 当 playlists 加载完成后，自动选择第一个歌单并触发其点击事件
    useEffect(() => {
        if (playlists.length > 0) {
            handlePlaylistChange(playlists[0].id);  // 自动选择第一个歌单
        }
    }, [playlists]);

    // 当歌曲列表(songs)更新时，自动播放第一个歌单的第一首歌曲
    useEffect(() => {
        if (songs.length > 0) {
            setCurrentSong(songs[0]);
        }
    }, [songs]);

    // useEffect(() => {
    //     const player = document.getElementById('youtube-player');
    //     if (player) {
    //       player.className = isPanelVisible ? 'playlist-player' : 'playlist-player-full';
    //     }
    //   }, [isPanelVisible]);

    const handleSongClick = (song) => {
        setCurrentSong(song);
    };

    const handleEditClick = () => {
        if (selectedPlaylist) {
            axios.get(`/api/playlists/${selectedPlaylist}`)
            .then(response => {
                if (response.status !== 200) {
                    throw new Error('Network response was not ok');
                }
                const data = response.data;
                setPlaylistDetails(data);
                setNewPlaylistName(data.name);
                setNewPlaylistVisibility(data.visibility);
                setNewPlaylistDescription(data.description);
                setNewPlaylistTags(data.tags);
                setNewPlaylistCategory(data.category);
                setIsEditModalVisible(true);
            })
            .catch(error => {
                console.error('Error fetching playlist details:', error);
            });
        }
    };    

    // 处理播放结束事件，自动播放下一首歌
    const handleSongEnd = () => {
        const currentIndex = songsRef.current.findIndex(song => song.resourceId === currentSongRef.current.resourceId);
        const nextIndex = (currentIndex + 1) % songsRef.current.length;;
        setCurrentSong(songsRef.current[nextIndex]);
        // console.log('Next Index:', nextIndex);
    };   

    //保存修改後的歌單信息
    const handleSaveChanges = () => {
        const requestBody = {
            name: newPlaylistName,
            visibility: newPlaylistVisibility,
            description: newPlaylistDescription,
            tags: newPlaylistTags,
            category: newPlaylistCategory
        };
    
        axios.put(`/api/playlists/${selectedPlaylist}`, requestBody, {
            headers: {
                'Content-Type': 'application/json',
                // Authorization 由全局拦截器自动处理
            }
        })
        .then(() => {
            setIsEditModalVisible(false);
            const updatedPlaylists = playlists.map(p => p.id === selectedPlaylist ? { ...p, ...requestBody } : p);
            setPlaylists(updatedPlaylists);
        })
        .catch(error => {
            console.error('Error updating playlist:', error);
        });
    };    

    // 打开新建歌单模态窗口
    const openCreatePlaylistModal = () => {
        setShowCreateModal(true);
    };
    // 打开新建電臺模态窗口
    const openCreateRadioModal = () => {
        setNewPlaylistName("");
        setNewPlaylistDescription("");
        setNewPlaylistTags("");
        setNewPlaylistCategory("");
        setShowCreateRadioModal(true);
    };
    // 关闭新建歌单模态窗口
    const closeCreatePlaylistModal = () => {
        setShowCreateModal(false);
    };
    // 关闭新建電臺模态窗口
    const closeCreateRadioModal = () => {
        setShowCreateRadioModal(false);
    };

    // 创建新歌单
    const handleCreatePlaylist = () => {
        const requestBody = {
            userId: user.id,
            name: newPlaylistName,
            type: 'song',
            visibility: newPlaylistVisibility,
            description: newPlaylistDescription,
            tags: newPlaylistTags,
            category: newPlaylistCategory
        };

        axios.post(`/api/playlists/create`, requestBody, {
            headers: {
                'Content-Type': 'application/json',
                // Authorization 由全局拦截器自动处理
            }
        })
        .then(response => {
            const data = response.data;
            // console.log('Playlist created:', data);
            showAlert(TranslateLanguage(localStorage.userLanguage, "歌單創建成功"));
            closeCreatePlaylistModal();
            
            // 重新获取歌单列表或刷新页面
            setPlaylists([...playlists, { id: data.playlistId, name: newPlaylistName }]);
        })
        .catch(error => {
            console.error('Error creating playlist:', error);
        });
    };
    // 创建新電臺
    const handleCreateRadio = () => {
        const requestBody = {
            userId: user.id,
            name: newPlaylistName,
            type: 'radio',
            visibility: newPlaylistVisibility,
            description: newPlaylistDescription,
            tags: newPlaylistTags,
            category: newPlaylistCategory
        };

        axios.post(`/api/playlists/create`, requestBody, {
            headers: {
                'Content-Type': 'application/json',
                // Authorization 由全局拦截器自动处理
            }
        })
        .then(response => {
            const data = response.data;
            // console.log('Playlist created:', data);
            showAlert(TranslateLanguage(localStorage.userLanguage, "電臺創建成功"));
            closeCreateRadioModal();
            
            // 重新获取歌单列表或刷新页面
            setPlaylists([...playlists, { id: data.playlistId, name: newPlaylistName }]);
        })
        .catch(error => {
            console.error('Error creating playlist:', error);
        });
    };
    //生成分享鏈接
    const handleSharePlaylistClick = () => {
        const urlPrefix = window.location.origin;
        axios.get(`/api/playlists/share/${selectedPlaylist}`)
        .then(response => {
            const data = response.data;
            if (data.shareLink) {
                const shareLink = `${urlPrefix}${data.shareLink}`;
                setShareLink(shareLink);
            } else {
                showAlert(TranslateLanguage(localStorage.userLanguage, "無法生成分享鏈接，可能歌單是私有的。"));
            }
        })
        .catch(error => {
            console.error("生成分享链接时出错:", error);
            showAlert(TranslateLanguage(localStorage.userLanguage, "生成分享鏈接失敗，請點擊“詳情”設置為“公開”！"));
        });
    };
    //將歌單存為電臺
    const handleSaveAsRadioClick = () => {
        setModalProps({
            userId: user.id, // 假设 user 对象里有 id 字段
            playlistId: selectedPlaylist,
            playlisttype: 'radio'
          });
        setshowPlaylistToRadioModal(true);
    };
    //刪除歌單
    const handleDeletePlaylistClick = () => {
        if (window.confirm(TranslateLanguage(localStorage.userLanguage, "確定刪除這個歌單？"))) {
            axios.delete(`/api/playlists/${selectedPlaylist}`)
            .then(response => {
                if (response.status === 200) {
                    // 从本地状态中移除被删除的歌单
                    setPlaylists(playlists.filter(playlist => playlist.id !== selectedPlaylist));
                    showAlert(TranslateLanguage(localStorage.userLanguage, "歌單刪除成功"));
                } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
                }
            })
            .catch(error => {
                console.error("删除歌单时出错:", error);
                showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
            });
        }
    };    

    const copyShareLink =()=> {
        copyToClipboard(shareLink);
        setShareLink(false)
      };

    const onDragEnd = ({ source, destination }) => {
        if (source && destination) {
          const reorderedSongs = euiDragDropReorder(songs, source.index, destination.index);
          setSongs(reorderedSongs);
            const songOrders = reorderedSongs.map((song, index) => ({
                songId: song.resourceId, 
                order: index + 1  // `index` 是从 0 开始的，因此我们加 1
            }));
        
            const payload = {
                playlistId: selectedPlaylist,
                songOrders: songOrders
            };

            axios.post(`/api/playlists/${selectedPlaylist}/reorder`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    // Authorization 由全局拦截器自动处理
                }
            })
            .then(response => {
                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                setSongs([...reorderedSongs]);
            })
            .catch(error => {
                console.error('Error saving song order:', error);
            });
        }
      };
    
    const togglePanel = () => {
        setIsPanelVisible(!isPanelVisible);
    };

    return (
     userRole === "Admin" && (
        <div className="adminRadioPageShell">
            <EuiFlexGroup 
                className="admin-radio-layout"
                gutterSize="none"
                responsive={false}
            >
            {/* 左侧播放窗口 */}
            {/* <EuiFlexItem ref={leftpanelRef} grow={isPanelVisible ? 2 : 3} style={{ position: 'sticky', top: 0,  zIndex: 100 }} className={isPanelVisible ? "left_video_item":  "left_video_item_full"}> */}
            <EuiFlexItem
                ref={leftpanelRef}
                grow={false}
                className={
                    isPanelVisible
                    ? 'admin-radio-left-panel admin-radio-left-panel--split'
                    : 'admin-radio-left-panel admin-radio-left-panel--full'
                }
                style={{
                    zIndex: 100,
                    minWidth: 0,
                    minHeight: 0,
                    flexShrink: 0
                }}
            >
                <EuiPanel 
                    className="admin-radio-player-panel"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'stretch',
                        width: '100%',
                        height: '100%',
                        minHeight: 0,
                        padding: '5px',
                        overflow: 'hidden'
                    }}  
                >
                    {currentSong ? (
                    <>
                        {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0', width: '100%' }}> */}
                        <div className="admin-radio-toolbar">
                            {/* 歌曲标题 */}
                            <h3 ref={songtitleRef} style={{ flex: 1, textAlign: 'center', margin: 0 }}>
                                {TranslateLanguage(localStorage.userLanguage, currentSong.name)}
                            </h3>
                            
                            {/* 按钮 */}
                            <EuiButtonEmpty
                                iconType={
                                    isPanelVisible
                                    ? 'arrowRight'
                                    : 'arrowLeft'
                                }
                                onClick={togglePanel}
                                style={{
                                    marginLeft: 'auto',
                                    flexShrink: 0
                                }}
                                >
                                {TranslateLanguage(
                                    localStorage.userLanguage,
                                    isPanelVisible
                                    ? '全屏'
                                    : '顯示列表'
                                )}
                            </EuiButtonEmpty>
                        </div>
                        {/* <div id="youtube-player" className = 'playlist-player'></div> */}
                        <div className="admin-radio-player-frame">
                            <div
                                id="youtube-player"
                                className="admin-radio-player"
                            />
                        </div>
                    </>
                    ) : (
                        <p>{TranslateLanguage(localStorage.userLanguage, "請點擊歌曲播放")}</p>
                    )}
                </EuiPanel>
            </EuiFlexItem>

            {/* 右侧歌单及歌曲显示 */}
            {isPanelVisible && (
                    <EuiFlexItem
                        grow={false}
                        className="admin-radio-right-panel"
                        style={{
                            minWidth: 0,
                            minHeight: 0,
                            height: '100%',
                            overflow: 'hidden'
                        }}
                    >
                    {/* <EuiPanel style={{ width: '100%', textAlign: 'center', zIndex: 1, display: 'flex', flexDirection: 'column'}}> 确保整个面板宽度一致 */}
                    <EuiPanel
                        className="admin-radio-list-panel"
                        style={{
                            width: '100%',
                            height: '100%',
                            minHeight: 0,
                            textAlign: 'center',
                            zIndex: 1,
                            overflow: 'hidden'
                        }}
                    >
                        {/* 顶部Logo和标题部分 */}
                        <div
                            className="admin-radio-list-header"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: 'pointer',
                                marginBottom: '8px',
                                width: '100%'
                            }}
                            onClick={() => navigate('/')}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src={logosmall} alt="Logo" style={{ width: '50px', height: '50px', marginBottom: '10px' }} />
                                <h2 style={{ margin: 10, textAlign: 'center' }}>{user ? `${TranslateLanguage(localStorage.userLanguage, user.username)}的電臺` : '我的歌单'}</h2>
                            </div>
                        </div>
                        {/* 歌单和歌曲列表部分 */}
                        <div className="admin-radio-list-scroll">
                            <EuiListGroup flush >
                            {playlists.map(playlist => (
                                <div key={playlist.id}>
                                        <EuiFlexGroup alignItems="center" gutterSize="s" direction="row">
                                            <EuiFlexItem grow={1}>
                                                <EuiListGroupItem
                                                    className={`playlist-item ${selectedPlaylist === playlist.id ? 'selected-playlist' : ''}`}
                                                    label={TranslateLanguage(localStorage.userLanguage, playlist.name)}
                                                    onClick={() => handlePlaylistChange(playlist.id)}
                                                    iconType={expandedPlaylist === playlist.id ? 'arrowDown' : 'arrowRight'}
                                                />
                                            </EuiFlexItem>
                                        </EuiFlexGroup>
                                        {expandedPlaylist === playlist.id && (
                                            <EuiDragDropContext onDragEnd={onDragEnd}>
                                                <EuiDroppable droppableId="DROPPABLE_AREA" spacing="none">
                                                    {songs.map((song, index) => (
                                                        <EuiDraggable spacing="none" key={song.resourceId} index={index} draggableId={song.name} paddingSize="none" hasBorder={true}>
                                                            {(provided, state) => (
                                                                 <SongItem
                                                                 song={song}
                                                                 currentSong={currentSong}
                                                                 handleSongClick={handleSongClick}
                                                                 handleDeleteSong={handleDeleteSong}
                                                             />
                                                            )}
                                                        </EuiDraggable>
                                                    ))}
                                                </EuiDroppable>
                                            </EuiDragDropContext>
                                        )}
                                    </div>
                                ))}
                            </EuiListGroup>

                            {/* <div style={{ width: '100%', padding: '5px', display: 'flex', justifyContent: 'space-evenly' }}> */}
                            <div className="admin-radio-list-actions">
                                {selectedPlaylist && (
                                    <>
                                    <EuiButtonEmpty iconType="advancedSettingsApp" size="s" onClick={handleEditClick}>
                                        {TranslateLanguage(localStorage.userLanguage, "詳情")}
                                    </EuiButtonEmpty>
                                    <EuiButtonEmpty iconType="trash" size="s" onClick={handleDeletePlaylistClick}>
                                        {TranslateLanguage(localStorage.userLanguage, "刪除")}
                                    </EuiButtonEmpty>
                                    {/* <EuiButtonEmpty iconType="share" size="s" onClick={handleSharePlaylistClick}>
                                        {TranslateLanguage(localStorage.userLanguage, "分享")}
                                    </EuiButtonEmpty> */}
                                    </>
                                )}
                                <EuiButtonEmpty iconType="listAdd" size="s" onClick={openCreateRadioModal}>
                                  {TranslateLanguage(localStorage.userLanguage, "新建")}
                                </EuiButtonEmpty>
                              </div>                                                                                                              
                        </div>
                    </EuiPanel>
                </EuiFlexItem>
            )}

            {/* 如果生成了分享链接，显示链接和复制按钮 */}
            {shareLink && (
                <EuiModal
                    onClose={() => setShareLink(false)}
                    style={{
                        maxWidth: '90%',
                        height: '90%',
                        minHeight: '50vh',
                        margin: 'auto'
                    }}
                >
                    <EuiModalHeader>
                        <h2 style={{ textAlign: 'center', width: '100%' }}>{TranslateLanguage(localStorage.userLanguage, "分享鏈接")}</h2>
                    </EuiModalHeader>
                
                    <EuiModalBody style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                        <div style={{ overflowX: 'auto', wordBreak: 'break-all', maxWidth: '100%' }}>
                            <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{shareLink}</p>
                        </div>
                    </EuiModalBody>
                
                    <EuiModalFooter style={{ display: 'flex'}}>
                        <EuiButton fill onClick={() => copyShareLink(shareLink)}>{TranslateLanguage(localStorage.userLanguage, "複製鏈接")}</EuiButton>
                        <EuiButton onClick={() => setShareLink(false)} color="danger">{TranslateLanguage(localStorage.userLanguage, "關閉")}</EuiButton>
                    </EuiModalFooter>
                </EuiModal>            
                )}

            {/* 编辑歌单模态窗口 */}
            {isEditModalVisible && (
                <EuiModal 
                    onClose={() => setIsEditModalVisible(false)}
                    style={{
                        maxWidth: '90%',
                        height: '90%',
                        minHeight: '50vh',
                        margin: 'auto'
                    }}
                >
                    <EuiModalHeader>
                        <h2>{TranslateLanguage(localStorage.userLanguage, "電臺詳情")}</h2>
                    </EuiModalHeader>
                    <EuiModalBody>
                        <EuiFieldText
                            placeholder={TranslateLanguage(localStorage.userLanguage, "電臺名稱")}
                            value={TranslateLanguage(localStorage.userLanguage, newPlaylistName)}
                            onChange={e => setNewPlaylistName(e.target.value)}
                            required
                            aria-label="歌單名稱"  // 增加無障礙支持
                            isInvalid={!newPlaylistName.trim()} // 若名称为空，设置为无效状态
                        />
                        <EuiSelect
                            options={[
                                { value: 'public', text: TranslateLanguage(localStorage.userLanguage, "公開")},
                                { value: 'private', text: TranslateLanguage(localStorage.userLanguage, "私有")},
                                { value: 'shareable', text: TranslateLanguage(localStorage.userLanguage, "可分享但不加入搜索列表")}
                            ]}
                            value={newPlaylistVisibility}
                            onChange={(e) => setNewPlaylistVisibility(e.target.value)}
                        />
                        <EuiTextArea
                            placeholder={TranslateLanguage(localStorage.userLanguage, "電臺描述")}
                            value={newPlaylistDescription}
                            onChange={(e) => setNewPlaylistDescription(e.target.value)}
                        />
                        <EuiFieldText
                            placeholder={TranslateLanguage(localStorage.userLanguage, "標籤(用逗號分隔)")}
                            value={newPlaylistTags}
                            onChange={(e) => setNewPlaylistTags(e.target.value)}
                        />
                        <EuiFieldText
                            placeholder={TranslateLanguage(localStorage.userLanguage, "分類")}
                            value={newPlaylistCategory}
                            onChange={(e) => setNewPlaylistCategory(e.target.value)}
                        />
                    </EuiModalBody>
                    <EuiModalFooter>
                        <EuiButton 
                        onClick={() => {
                            if (newPlaylistName.trim()) {
                                handleSaveChanges();
                            } else {
                                showAlert(TranslateLanguage(localStorage.userLanguage, "電臺名稱為必填項"));
                            }
                        }} 
                        fill
                    >
                        {TranslateLanguage(localStorage.userLanguage, "保存更改")}
                    </EuiButton>
                        <EuiButton onClick={() => setIsEditModalVisible(false)} color="danger">{TranslateLanguage(localStorage.userLanguage, "取消")}</EuiButton>                  
                    </EuiModalFooter>
                </EuiModal>
            )}


            {/* 新建歌单模态窗口 */}
            {showCreateModal && (
            <EuiModal 
                onClose={closeCreatePlaylistModal}
                style={{
                    maxWidth: '90%',
                    height: '90%',
                    minHeight: '50vh',
                    margin: 'auto'
                }}
            >
                <EuiModalHeader>
                    <h2>{TranslateLanguage(localStorage.userLanguage, "創建新的歌單")}</h2>
                </EuiModalHeader>
                <EuiModalBody>
                    <EuiFieldText
                        placeholder={TranslateLanguage(localStorage.userLanguage, "歌單名稱")}
                        value={newPlaylistName}
                        onChange={e => setNewPlaylistName(e.target.value)}
                        required
                        aria-label="歌單名稱"  // 增加無障礙支持
                        isInvalid={!newPlaylistName.trim()} // 若名称为空，设置为无效状态
                    />
                    <EuiSelect
                        options={[
                            { value: 'public', text: TranslateLanguage(localStorage.userLanguage, "公開")},
                            { value: 'private', text: TranslateLanguage(localStorage.userLanguage, "私有")},
                            { value: 'shareable', text: TranslateLanguage(localStorage.userLanguage, "可分享但不加入搜索列表")}
                        ]}
                        value={newPlaylistVisibility}
                        onChange={e => setNewPlaylistVisibility(e.target.value)}
                    />
                    <EuiTextArea
                        placeholder={TranslateLanguage(localStorage.userLanguage, "歌單描述")}
                        value={newPlaylistDescription}
                        onChange={e => setNewPlaylistDescription(e.target.value)}
                    />
                    <EuiFieldText
                        placeholder={TranslateLanguage(localStorage.userLanguage, "標籤(用逗號分隔)")}
                        value={newPlaylistTags}
                        onChange={e => setNewPlaylistTags(e.target.value)}
                    />
                    <EuiFieldText
                        placeholder={TranslateLanguage(localStorage.userLanguage, "分類")}
                        value={newPlaylistCategory}
                        onChange={e => setNewPlaylistCategory(e.target.value)}
                    />
                </EuiModalBody>
                <EuiModalFooter>
                    <EuiButton 
                        onClick={() => {
                            if (newPlaylistName.trim()) {
                                handleCreatePlaylist();
                            } else {
                                showAlert(TranslateLanguage(localStorage.userLanguage, "歌單名稱為必填項"));
                            }
                        }} 
                        fill
                    >
                        {TranslateLanguage(localStorage.userLanguage, "創建")}
                    </EuiButton>
                    <EuiButton onClick={closeCreatePlaylistModal} color="danger">{TranslateLanguage(localStorage.userLanguage, "取消")}</EuiButton>
                </EuiModalFooter>
            </EuiModal>        
            )}
            {/* 渲染 RadioModal */}
            {showPlaylistToRadioModal && (
                <RadioModal
                  userId={modalProps.userId}
                  playlistId={modalProps.playlistId}
                  playlisttype={modalProps.playlisttype}
                  closeModal={() => setshowPlaylistToRadioModal(false)}
                />
              )}
            {/* 新建電臺模态窗口 */}
            {showCreateRadioModal && (
            <EuiModal 
                onClose={closeCreateRadioModal}
                style={{
                    maxWidth: '90%',
                    height: '90%',
                    minHeight: '50vh',
                    margin: 'auto'
                }}
            >
                <EuiModalHeader>
                    <h2>{TranslateLanguage(localStorage.userLanguage, "創建新的電臺")}</h2>
                </EuiModalHeader>
                <EuiModalBody>
                    <EuiFieldText
                        placeholder={TranslateLanguage(localStorage.userLanguage, "電臺名稱")}
                        value={newPlaylistName}
                        onChange={e => setNewPlaylistName(e.target.value)}
                        required
                        aria-label="電臺名稱"  // 增加無障礙支持
                        isInvalid={!newPlaylistName.trim()} // 若名称为空，设置为无效状态
                    />
                    <EuiSelect
                        options={[
                            { value: 'public', text: TranslateLanguage(localStorage.userLanguage, "公開")},
                            { value: 'private', text: TranslateLanguage(localStorage.userLanguage, "私有")},
                            { value: 'shareable', text: TranslateLanguage(localStorage.userLanguage, "可分享但不加入搜索列表")}
                        ]}
                        value={newPlaylistVisibility}
                        onChange={e => setNewPlaylistVisibility(e.target.value)}
                    />
                    <EuiTextArea
                        placeholder={TranslateLanguage(localStorage.userLanguage, "電臺描述")}
                        value={newPlaylistDescription}
                        onChange={e => setNewPlaylistDescription(e.target.value)}
                    />
                    <EuiFieldText
                        placeholder={TranslateLanguage(localStorage.userLanguage, "標籤(用逗號分隔)")}
                        value={newPlaylistTags}
                        onChange={e => setNewPlaylistTags(e.target.value)}
                    />
                    <EuiFieldText
                        placeholder={TranslateLanguage(localStorage.userLanguage, "分類")}
                        value={newPlaylistCategory}
                        onChange={e => setNewPlaylistCategory(e.target.value)}
                    />
                </EuiModalBody>
                <EuiModalFooter>
                    <EuiButton 
                        onClick={() => {
                            if (newPlaylistName.trim()) {
                                handleCreateRadio();
                            } else {
                                showAlert(TranslateLanguage(localStorage.userLanguage, "電臺名稱為必填項"));
                            }
                        }} 
                        fill
                    >
                        {TranslateLanguage(localStorage.userLanguage, "創建")}
                    </EuiButton>
                    <EuiButton onClick={closeCreateRadioModal} color="danger">{TranslateLanguage(localStorage.userLanguage, "取消")}</EuiButton>
                </EuiModalFooter>
            </EuiModal>        
            )}
        </EuiFlexGroup>
        </div>
     )
    );
}

export default RadioPageWithPlayer;
